import React, { useEffect, useState } from "react";
import "../sections.css";
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function CasaAbierta() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        const tarjetaCasa = tarjetas.find(
          (t: any) => t.titulo === "CASA ABIERTA"
        );
        setData(tarjetaCasa);
      } catch (error) {
        console.error("Error cargando Casa Abierta:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const imageUrl = data?.portada?.url || null;

  return (
    <section className="section casa-abierta">
      <div className="section-inner">
        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999] pointer-events-none" />
          ) : (
            <div
              className="media-cover"
              style={{
                backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
              }}
            />
          )}
          <a href="/casa-abierta" className="full-link" aria-label="Ir a Casa Abierta" />
        </div>

        <div className="col-text">
          {loading ? (
            <TextSkeleton className="relative z-[99999] pointer-events-none" />
          ) : (
            <h1>
              {data?.Titulo?.split(" ").map((word: string, i: number) => (
                <React.Fragment key={`${word}-${i}`}>
                  {word} {i === 0 && <br />}
                </React.Fragment>
              )) || "CASA ABIERTA"}
            </h1>
          )}
          <a href="/casa-abierta" className="full-link" aria-label="Ir a Casa Abierta" />
        </div>
      </div>
    </section>
  );
}